/**
 * Browser OTLP hook (env-guarded). Full SDK wiring is optional; see OBSERVABILITY.md.
 * Payout-app uses the same REACT_APP_* placeholders without bundling OTel yet.
 */
export function initializeBrowserOtel() {
  if (process.env.VUE_APP_ENABLE_OTEL !== "true") {
    return;
  }
  const endpoint =
    process.env.VUE_APP_OTEL_EXPORTER_OTLP_ENDPOINT ||
    "http://127.0.0.1:60494/v1/traces";
  const serviceName =
    process.env.VUE_APP_OTEL_SERVICE_NAME || "rocketfuel-payment-page";
  console.debug("[obs] Browser OTEL enabled (stub)", { endpoint, serviceName });
}
